import rsaSignaturePiecesDb from '../../lib/gqlDB/rsaSignaturePieces';
import { displayActions } from '../slices/display';
import { workspaceActions } from '../slices/workspace';

export const saveRsaSignaturePieces = rsaSignaturePieces => dispatch => {
    dispatch(workspaceActions.SUBMITTING_DATA());

    return rsaSignaturePiecesDb
        .updatePieces(rsaSignaturePieces)
        .then(() => {
            dispatch(workspaceActions.RSA_SIGNATURE_PIECES({rsaSignaturePieces}));
            dispatch(displayActions.TOGGLE_MANAGE_RSA_SIGNATURE_DIALOG());
        })
        .catch(error => dispatch(workspaceActions.ACTION_ERROR(error)));
};

export const loadRsaSignaturePieces = () => dispatch => {
    dispatch(workspaceActions.SUBMITTING_DATA());

    return rsaSignaturePiecesDb.getPieces()
        .then(rsaSignaturePieces => {
            dispatch(workspaceActions.RSA_SIGNATURE_PIECES_LOADED({rsaSignaturePieces}));
        })
        .catch(error => dispatch(workspaceActions.ACTION_ERROR(error)));
};